import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../actions/EmailAuthenticationActions";
import UrlHelper from "../../utilities/UrlHelper";
import ValidationHelper from "../../utilities/ValidationHelper";
import ResetPassword from "./setPassword/ResetPassword";
import CompleteResetPassword from "./CompleteResetPassword";
import ticketType from "../../entities/TicketType";

export class ResetPasswordPage extends Component {
    constructor (props) {
        super(props);

        this.state = {
            errorMessage: undefined
        };

        this.handleReset = this.handleReset.bind(this);
        this.onCompleteClick = this.onCompleteClick.bind(this);
    }

    componentDidMount() {
        import("./_styles.scss");
        const ticket = UrlHelper.getParameterByName("ticket");
        if (!ValidationHelper.isNullOrEmpty(ticket))
            this.props.validateVirtualUserTicket(ticket);
    }

    handleReset (password) {
        const ticket = UrlHelper.getParameterByName("ticket");
        if (!ValidationHelper.isNullOrEmpty(ticket))
            this.props.resetPassword(ticket, password);
    }

    onCompleteClick () {
        if (this.props.redirectLocationOnSuccess)
            window.location = this.props.redirectLocationOnSuccess;
    }

    render () {
        if (this.props.redirectLocationOnError) {
            window.location = this.props.redirectLocationOnError;
        }

        const redirectLocationOnSuccess = this.props.redirectLocationOnSuccess;

        return (
            <div>
                {!redirectLocationOnSuccess &&
                <ResetPassword
                    passwordRequirements={this.props.passwordRequirements}
                    passwordValidationUserData={this.props.passwordValidationUserData}
                    onComplete={this.handleReset}
                    serverError={this.props.errorMessage}
                    isPasswordSetting={this.props.isPasswordSetting}
                    email={this.props.email}/>}
                {redirectLocationOnSuccess &&
                <CompleteResetPassword
                    onComplete={this.onCompleteClick}
                    email={this.props.email} />}
            </div>
        );
    }
}

ResetPasswordPage.defaultProps = {
    validateVirtualUserTicket: () => {}
};

ResetPasswordPage.propTypes = {
    resetPassword: PropTypes.func,
    validateVirtualUserTicket: PropTypes.func,
    errorMessage: PropTypes.string,
    email: PropTypes.string,
    passwordValidationUserData: PropTypes.object,
    passwordRequirements: PropTypes.object,
    redirectLocationOnSuccess: PropTypes.string,
    redirectLocationOnError: PropTypes.string,
    isPasswordSetting: PropTypes.bool
};

const mapStateToProps = state => ({
    errorMessage: state.setPasswordState.errorMessage,
    email: state.setPasswordState.email,
    passwordValidationUserData: state.setPasswordState.passwordValidationUserData,
    passwordRequirements: state.setPasswordState.passwordRequirements,
    redirectLocationOnSuccess: state.setPasswordState.redirectLocationOnSuccess,
    redirectLocationOnError: state.setPasswordState.redirectLocationOnError,
    isPasswordSetting: state.setPasswordState.isPasswordSetting
});

const mapDispatchToProps = (dispatch) => {
    return ({
        resetPassword: (ticket, password) => dispatch(actions.resetPassword(ticket, password)),
        validateVirtualUserTicket: (ticket) => dispatch(actions.validateVirtualUserTicket(ticket, ticketType.virtualUser.resetPassword.value))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);
